import { useEffect, useCallback } from 'react';

import { useScreenMessage } from '@gogame/screens';
import { useSocket } from '@gogame/sockets';

export const useSocketMessage = () => {
  const socket = useSocket();
  const { showErrorMessage, showSuccessMessage, showMessage } =
    useScreenMessage();

  const handlerOnMessage = useCallback(({ type, message }) => {
    const messageOptions = { ttl: 5000, closable: true };
    switch (type) {
      case 'error':
        showErrorMessage(message, messageOptions);
        break;
      case 'success':
        showSuccessMessage(message, messageOptions);
        break;
      case 'neutral':
      default:
        showMessage(message, messageOptions);
        break;
    }
  }, []);

  useEffect(() => {
    socket.on('message', handlerOnMessage);
    return () => {
      socket.off('message', handlerOnMessage);
    };
  }, [socket]);
};
